<template>
  <div>
    <v-alert
      v-if="localData.userLoanModel != null"
      icon="mdi-shield-lock-outline"
      prominent
      text
      type="info"
    >
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          {{ localData.userLoanModel.loanModel.title }}
          <br>
          {{ localData.userLoanModel.amount.toString().toPriceFormat() }} ریال
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          شروع:
          <br>
          {{ localData.userLoanModel.startDate_Persian.date }}
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          هر قسط:
          <br>
          {{
            localData.userLoanModel.installment.toString().toPriceFormat()
          }}
          ریال
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          باقیمانده:
          <br>
          {{ localData.userLoanModel.remain.toString().toPriceFormat() }} ریال
        </v-col>
      </v-row>
    </v-alert>

    <v-form
      ref="form"
      class="mx-2"
      lazy-validation
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-money
            ref="amount"
            v-model="localData.amount"
            :label="'مبلغ*'"
            :error-messages="errorMessages"
            :rules="[
              () =>
                localData.amount > 0 || 'مبلغ قسط را به صورت صحیح وارد کنید',
              () =>
                localData.amount <=
                localData.userLoanModel.remain + initValue ||
                'مبلغ قسط از مبلغ باقیمانده نباید بیشتر باشد.',
            ]"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="installmentNumber"
            v-model="localData.installmentNumber"
            label="شماره قسط*"
            :error-messages="errorMessages"
            :rules="[
              () =>
                !!localData.installmentNumber > 0 ||
                'شماره قسط را به صورت صحیح وارد کنید',
            ]"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <div>
            <div>مربوط به</div>
            <date-picker
              ref="targetMonth"
              v-model="localData.targetMonth"
              format="YYYY-MM-DDTHH:mm:ss"
              auto-submit
              display-format="jYYYY/jMM"
              :error-messages="errorMessages"
              :rules="[
                () =>
                  !!localData.targetMonth ||
                  'تاریخ شروع را به صورت صحیح وارد کنید',
              ]"
            />
          </div>
        </v-col>
      </v-row>
      <small>برای این فیلد روز مهم نمی باشد و ماه و سال ملاک می باشد.</small>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('callbck', false)">
        بستن
      </v-btn>
      <v-btn
        color="blue"
        dark
        :loading="submitLoading"
        @click="submit()"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import { emptyId } from '@/util/emptyId'
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  export default {
    name: 'ModifyLoanPaymentView',
    components: {
      'date-picker': VuePersianDatetimePicker,
    },
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        submitLoading: false,
        targetMonth: '',
        initValue: 0,
      }
    },
    mounted () {},
    methods: {
      submit () {
        if (!this.$refs.form.validate()) {
          return
        }
        this.submitLoading = true
        api
          .post(
            'admin/loanpayment/' +
              (this.localData.id === emptyId ? 'create' : 'edit'),
            this.localData,
          )
          .then((response) => {
            toast.success('اطلاعات با موفقیت ذخیره شد.')
            this.$emit('callbck', true)
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.submitLoading = false
          })
      },
      prepareData () {
        if (!this.data) {
          this.data = { id: emptyId }
        }
        if (!this.data.id) {
          this.data.id = emptyId
        }
        api
          .get('admin/loanpayment/get/' + this.data.id, null)
          .then((response) => {
            this.localData = response
            if (this.data.id === emptyId) { Object.assign(this.localData, this.data) } else this.initValue = response.amount
          // this.localData.userLoanModel = this.data.userLoanModel
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
